import store from '@/store'
import { registerSingletonResourceWithStore } from '@/services/GenericSingletonResourceService'
import _ from 'lodash'
import { updatedDiff } from 'deep-object-diff'
import CostingLayout from './CostingLayout.vue'

registerSingletonResourceWithStore('costingDefaults', 'costing/defaults', store)

// Sync changes from costing defaults to root store module.
setTimeout(() => {
  store.watch(
    state => ({
      costingMode: state.costingDefaults.originalData.costingMode,
      jobRequired: state.costingDefaults.originalData.jobRequired,
      canRestrictJobAccessByUser:
        state.costingDefaults.originalData.canRestrictJobAccessByUser,
    }),
    syncSettings => {
      if (syncSettings.costingMode === undefined) {
        // This is a litmus test to determine whether Vue is just loading,
        // or whether something actually changed.
        return
      }
      // Get same keys in root state
      const rootSettings = _.pick(store.state, Object.keys(syncSettings))
      const updated = updatedDiff(rootSettings, syncSettings)
      if (!_.isEmpty(updated)) {
        store.dispatch('updateSession', updated)
      }
    }
  )
})

export default {
  name: 'costing',
  label: 'Costing',
  link: 'costing',
  path: 'costing',
  props: true,
  icon: 'industry',
  description: 'View and edit your costing settings, including jobs.',
  component: CostingLayout,
  requirePerm: 'edit_jobs',
  requireFeature: 'job_costing',
  require: (state, getters) => {
    // If costing is not enabled, then only allow costing route if user has
    // permission to enable costing.
    return state.permissions.includes('edit_settings') || getters.costingEnabled
  },
  breadcrumbLeaf: true,
  children: [
    {
      name: 'job-list',
      navIcon: 'Briefcase',
      description: 'Jobs that workers can clock time against.',
      label: 'Jobs',
      path: 'jobs/:view?',
      requireGetter: 'costingEnabled',
      component: () => import('./JobList.vue'),
    },
    {
      name: 'job-phase-list',
      navIcon: 'ListOrdered',
      label: 'Job Phases',
      path: 'job-phases/:view?',
      requireGetter: 'enhancedCostingEnabled',
      component: () => import('./JobPhaseList.vue'),
    },
    {
      name: 'cost-code-list',
      navIcon: 'Hash',
      label: 'Cost Codes',
      path: 'cost-codes/:view?',
      requireGetter: 'enhancedCostingEnabled',
      component: () => import('./CostCodeList.vue'),
    },
    {
      name: 'costing-defaults',
      navIcon: 'SlidersHorizontal',
      label: 'Settings',
      title: 'Costing Settings',
      path: 'defaults',
      requirePerm: 'edit_settings',
      component: () => import('./CostingDefaultsForm.vue'),
    },
    {
      name: 'costing-index',
      path: '',
      nav: false,
      // beforeEnter (unlike redirect) runs after the router has waited for app state to load, so this
      // reads accurate feature/permission state instead of racing it on a hard page load (e.g. new tab).
      beforeEnter: to => {
        // Prefer Jobs as the first tab when costing is enabled.
        return {
          name: store.getters.costingEnabled
            ? 'job-list'
            : 'costing-defaults',
          params: to.params,
        }
      },
    },
  ],
}
